export const TYPE_IMAGE = 'picture';
export const TYPE_VIDEO = 'video';

export default function requestCredentials(request, type) {
  return request(`/media/credentials/${type}`);
}
